import { atom } from "jotai";

import { SensitivitySortBy } from "@modules/_shared/SensitivityProcessing";
import { ColorBy, DisplayComponentType, SensitivityScaling } from "@modules/SensitivityPlot/typesAndEnums";

export const displayComponentTypeAtom = atom<DisplayComponentType>(DisplayComponentType.SENSITIVITY_CHART);
export const referenceSensitivityNameAtom = atom<string | null>(null);
export const responseChannelNameAtom = atom<string | null>(null);
export const hideZeroYAtom = atom<boolean>(false);
export const showLabelsAtom = atom<boolean>(true);
export const showSensitivityMeanPointsAtom = atom<boolean>(false);
export const showRealizationPointsAtom = atom<boolean>(false);
export const sensitivitySortByAtom = atom<SensitivitySortBy>(SensitivitySortBy.IMPACT);
export const sensitivityScalingAtom = atom<SensitivityScaling>(SensitivityScaling.RELATIVE);
export const colorByAtom = atom<ColorBy>(ColorBy.LOW_HIGH);
